import { render } from "./TheRegister.vue?vue&type=template&id=2d14d5f9&scoped=true"
import script from "./TheRegister.vue?vue&type=script&lang=js"
export * from "./TheRegister.vue?vue&type=script&lang=js"

import "./TheRegister.vue?vue&type=style&index=0&id=2d14d5f9&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d14d5f9"]])

export default __exports__